import Head from 'next/head';
import { useRouter } from 'next/router';
import { FC } from 'react';

const PageHead: FC<{ children?: React.ReactNode }> = ({ children }) => {
    const router = useRouter();

    return (
        <Head>
            <title>Plenty</title>
            <meta
                name="description"
                content="Financial tools for the rest of us"
            />
            {/* https://developer.apple.com/documentation/webkit/promoting_apps_with_smart_app_banners */}
            <meta
                name="apple-itunes-app"
                content="app-id=6636471489"
                app-argument={router.asPath}
            />
            <link rel="icon" href="/favicon.ico" />
            {children}
        </Head>
    );
};

export default PageHead;
